import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useState } from 'react';
import { useSubscribedState } from '@/hooks/useSubscribedState';
import type { HTMLTagProps } from '@/types';
type InputType = 'text' | 'number' | 'large-number' | 'phone-number' | 'text-date' | 'password' | 'button' | 'search';
export interface InputProps extends Omit<HTMLTagProps<'input'>, 'type' | 'value' | 'width' | 'height' | 'size'> {
  type?: InputType;
  value?: number | string;
  ref?: React.Ref<HTMLInputElement>;
  textAlign?: 'left' | 'center' | 'right';
}
export const Input = t0 => {
  const $ = _c(50);
  let className;
  let onBlur;
  let onChange;
  let onFocus;
  let onInvalid;
  let placeholder;
  let ref;
  let restInputProps;
  let t1;
  let t2;
  let value;
  if ($[0] !== t0) {
    ({
      type: t1,
      value,
      textAlign: t2,
      placeholder,
      className,
      onFocus,
      onBlur,
      onInvalid,
      onChange,
      ref,
      ...restInputProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = onBlur;
    $[3] = onChange;
    $[4] = onFocus;
    $[5] = onInvalid;
    $[6] = placeholder;
    $[7] = ref;
    $[8] = restInputProps;
    $[9] = t1;
    $[10] = t2;
    $[11] = value;
  } else {
    className = $[1];
    onBlur = $[2];
    onChange = $[3];
    onFocus = $[4];
    onInvalid = $[5];
    placeholder = $[6];
    ref = $[7];
    restInputProps = $[8];
    t1 = $[9];
    t2 = $[10];
    value = $[11];
  }
  const type = t1 === undefined ? "text" : t1;
  const textAlign = t2 === undefined ? "left" : t2;
  const [isFormattedValue, setIsFormattedValue] = useState(true);
  const [inputValue, setInputValue] = useSubscribedState(value);
  let t3;
  if ($[12] !== isFormattedValue || $[13] !== placeholder || $[14] !== type) {
    t3 = value_0 => {
      if (type === "button" && !value_0) {
        return placeholder ?? "";
      }
      if (value_0 !== 0 && !value_0) {
        return "";
      }
      const valueString = String(value_0);
      if (!isFormattedValue) {
        return valueString;
      }
      switch (type) {
        case "number":
          {
            return valueString;
          }
        case "large-number":
          {
            return Number(valueString).toLocaleString();
          }
        case "phone-number":
          {
            if (valueString.length === 10) {
              return valueString.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
            }
            return valueString.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
          }
        case "text-date":
          {
            const textDate = valueString.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3");
            return Number.isNaN(new Date(textDate).getTime()) ? valueString : textDate;
          }
        default:
          {
            return valueString;
          }
      }
    };
    $[12] = isFormattedValue;
    $[13] = placeholder;
    $[14] = type;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  const formatValue = t3;
  let t4;
  if ($[16] !== inputValue || $[17] !== type) {
    t4 = value_1 => {
      switch (type) {
        case "number":
        case "large-number":
          {
            if (value_1 === "") {
              return value_1;
            }
            const isValidNumber = /^[0-9]+$/.test(value_1);
            return isValidNumber ? value_1 : inputValue;
          }
        case "phone-number":
          {
            let numberString_0 = value_1.replaceAll(/[^0-9]/g, "");
            if (numberString_0.length > 11) {
              numberString_0 = numberString_0.slice(0, 11);
            }
            return value_1 && numberString_0;
          }
        case "text-date":
          {
            let numberString = value_1.replaceAll(/[^0-9]/g, "");
            if (numberString.length > 8) {
              numberString = numberString.slice(0, 8);
            }
            return value_1 && numberString;
          }
        default:
          {
            return value_1;
          }
      }
    };
    $[16] = inputValue;
    $[17] = type;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  const convertChangeHandlerParam = t4;
  const t5 = type === "button" && "cursor-pointer overflow-hidden text-ellipsis disabled:cursor-default";
  const t6 = !value && type === "button" && "text-Gray-500";
  const t7 = textAlign === "left" && "text-start";
  const t8 = textAlign === "center" && "text-center";
  const t9 = textAlign === "right" && "text-end";
  let t10;
  if ($[19] !== className || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8 || $[24] !== t9) {
    t10 = cn("w-full border-none bg-inherit p-0 font-[inherit] text-[inherit] text-inherit outline-none transition-colors duration-300 placeholder:text-Gray-500", t5, t6, t7, t8, t9, className);
    $[19] = className;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== formatValue || $[27] !== inputValue) {
    t11 = formatValue(inputValue);
    $[26] = formatValue;
    $[27] = inputValue;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== onBlur) {
    t12 = e => {
      setIsFormattedValue(true);
      onBlur?.(e);
    };
    $[29] = onBlur;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== convertChangeHandlerParam || $[32] !== onChange || $[33] !== setInputValue) {
    t13 = e_0 => {
      const convertedValue = convertChangeHandlerParam(e_0.target.value);
      if (convertedValue !== null) {
        setInputValue(convertedValue);
        onChange?.(e_0);
      }
    };
    $[31] = convertChangeHandlerParam;
    $[32] = onChange;
    $[33] = setInputValue;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== onFocus) {
    t14 = e_1 => {
      setIsFormattedValue(false);
      onFocus?.(e_1);
    };
    $[35] = onFocus;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== onInvalid) {
    t15 = e_2 => {
      e_2.preventDefault();
      onInvalid?.(e_2);
    };
    $[37] = onInvalid;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== placeholder || $[40] !== ref || $[41] !== restInputProps || $[42] !== t10 || $[43] !== t11 || $[44] !== t12 || $[45] !== t13 || $[46] !== t14 || $[47] !== t15 || $[48] !== type) {
    t16 = <input {...restInputProps} ref={ref} className={t10} placeholder={placeholder} type={type} value={t11} onBlur={t12} onChange={t13} onFocus={t14} onInvalid={t15} />;
    $[39] = placeholder;
    $[40] = ref;
    $[41] = restInputProps;
    $[42] = t10;
    $[43] = t11;
    $[44] = t12;
    $[45] = t13;
    $[46] = t14;
    $[47] = t15;
    $[48] = type;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  return t16;
};